import Service from './service.js';
import { errorMessage } from '@/utils/message.js';

export default {
  props: {
    bankId: {
      type: Number | String,
      default: null
    },
    type: {
      type: String,
      default: ''
    },
    changeBankFlag: {
      type: Boolean,
      default: false
    },
    bidId: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      bankList: [],
      showDialog: false,
      defaultBankId: '',
      tempBankInfo: { },
      defaultBankInfo: {
        accName: '',
        bankName: '',
        accBankCardNo: ''
      }
    };
  },
  watch: {
    bankId(value, oldValue) {
      if(!value && oldValue) {
        this.$emit('update:bankId', oldValue);
      } else if(value && oldValue) {
        this.defaultBankInfo = this.bankList.find(item => item.id === Number(this.bankId));
      }
    },
    changeBankFlag (value) {
      if(value) {
        this.getBankList();
        this.showDialog = true;
      }
    },
    showDialog (flag) {
      !flag && this.$emit('update:changeBankFlag', false);
    }
  },
  created() {
    this.$nextTick(() => {
      this.defaultBankId = this.bankId;
      this.getBankList();
    });
  },
  methods: {
    // 获取银行卡列表
    getBankList(){
      let that = this;
      Service.getBankList().then(res => {
        if (res && res.code === '0') {
          that.bankList = res.data;
          // 如果传过来的银行卡ID没有，则取银行卡列表中默认的，如果没有默认的，则取第一条
          const result = res.data.find(item => item.id === Number(that.bankId));
          // 如果传过来的有银行ID
          if(that.bankId && result) {
            that.defaultBankInfo = result;
          } else {
            // 如果没有就传默认的ID
            let defaultBank = res.data.find(item => item.defaultIdentity === 1);
            that.defaultBankInfo = defaultBank;
            if (!defaultBank) {
              that.defaultBankInfo = res.data[0];
            }
            that.defaultBankId = that.defaultBankInfo.id;
            that.$emit('update:bankId', that.defaultBankId);
          }
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 选择银行账户
    selectedBank(bankObj) {
      this.defaultBankId = bankObj.id;
      this.tempBankInfo = bankObj;
    },
    // 确认选择
    confirmSelected () {
      if(this.tempBankInfo.id) {
        this.defaultBankInfo = this.tempBankInfo;
      }
      this.$emit('update:bankId', this.defaultBankInfo.id);
      this.showDialog = false;
    },
    // 添加银行卡
    toAddBankPage () {
      this.$router.push('/person-center/account-info/bank-account-manage/add');
    },
    // 确认变更银行卡
    confirmChangeBank () {
      let params = {
        bidId: this.bidId,
        bankId: this.defaultBankId
      };
      Service.updateSignBank(params).then(({code}) => {
        if (code === '0') {
          this.$successMessage('变更成功');
          this.showDialog = false;
          this.$emit('update:changeBankFlag', false);
        }
      }).catch(() => {
        this.$errorMessage('变更成功');
      });
    }
  }
};
